import { useEffect, useState } from "react";
import { describeCarrierContactPrefill } from "~/shared/documents/carrier-contact-prefill-description";
import type { CarrierContactPrefill } from "~/shared/documents/schemas/carrier-contact-prefill.schema";
import { Radio, Stack, Textarea } from "~/ui";

type CarrierContactPrefillFieldProps = {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  carrierContactPrefill: CarrierContactPrefill;
};

/** Create-modal carrier contact field with 0/1/many supplier-contact prefill behavior. @see docs/OPT_IN_ORDER_DOCUMENTS.md */
export const CarrierContactPrefillField = ({ label, value, onChange, error, carrierContactPrefill }: CarrierContactPrefillFieldProps) => {
  const [selectedContactId, setSelectedContactId] = useState(
    () => carrierContactPrefill.candidates.find(candidate => candidate.formattedValue === value)?.contactId ?? "",
  );

  useEffect(() => {
    const matchingCandidate = carrierContactPrefill.candidates.find(candidate => candidate.formattedValue === value);
    setSelectedContactId(matchingCandidate?.contactId ?? "");
  }, [carrierContactPrefill.candidates, value]);

  return (
    <Stack spacing="xs">
      {carrierContactPrefill.candidates.length > 1 && (
        <Radio.Group
          label="Select carrier contact"
          value={selectedContactId}
          onChange={contactId => {
            const candidate = carrierContactPrefill.candidates.find(entry => entry.contactId === contactId);
            if (candidate) {
              setSelectedContactId(contactId);
              onChange(candidate.formattedValue);
            }
          }}
        >
          <Stack spacing="xs">
            {carrierContactPrefill.candidates.map(candidate => (
              <Radio key={candidate.contactId} value={candidate.contactId} label={candidate.label} />
            ))}
          </Stack>
        </Radio.Group>
      )}
      <Textarea
        label={label}
        description={describeCarrierContactPrefill(carrierContactPrefill)}
        minRows={3}
        value={value}
        onChange={event => onChange(event.currentTarget.value)}
        error={error}
      />
    </Stack>
  );
};
